/** Timings shared by the compact cursor pill, summoned input bar and tray. */
export const REVEAL_DOT_SIZE = 6;
export const REVEAL_MS = 140;
export const RETRACT_WIDTH_MS = 160;
export const RETRACT_HEIGHT_DELAY_MS = 80;
export const RETRACT_HEIGHT_MS = 80;
export const RETRACT_MS = 240;
export const CROSSFADE_OUT_MS = 80;
export const CROSSFADE_IN_MS = 120;
export const MORPH_MS = 180;
export const CONFIRM_MS = 900;
/**
 * A native glass morph starts this long after it is requested, so the plate
 * is in place before the webview moves or shows anything on the same clock.
 */
export const PLATE_LEAD_MS = 48;

export type RevealStage = "dot" | "open" | "idle" | "exit";

/** Cubic-bezier control points `[x1, y1, x2, y2]`. */
export type CubicBezier = readonly [number, number, number, number];

/** CSS `ease-out`, shared by webview animations and native glass morphs. */
export const REVEAL_BEZIER: CubicBezier = [0, 0, 0.58, 1];
export const REVEAL_EASE = `cubic-bezier(${REVEAL_BEZIER.join(", ")})`;
export const RETRACT_EASE = "ease-in";

export const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

export function prefersReducedMotion(): boolean {
  return (
    typeof window !== "undefined" &&
    window.matchMedia?.(REDUCED_MOTION_QUERY).matches === true
  );
}
